export const MAX_BROKER_HOST_LENGTH = 256
export const MIN_BROKER_PORT = 1
export const MAX_BROKER_PORT = 65535

export const BROKER_FALLBACK_LABEL = 'Server default'

const HOSTNAME_PATTERN = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/

export const validateBrokerHost = (value: string): string | null => {
	const host = value.trim()
	if (!host) {
		return 'Broker host cannot be empty'
	}
	if (host.includes('://')) {
		return 'Enter the hostname only, without a protocol'
	}
	if (/\s/.test(host)) {
		return 'Broker host cannot contain spaces'
	}
	if (host.includes('/')) {
		return 'Enter the hostname only, without a path'
	}
	if (host.includes(':')) {
		return 'Enter the port in the Broker Port field'
	}
	if (host.length > MAX_BROKER_HOST_LENGTH) {
		return `Broker host must be ${MAX_BROKER_HOST_LENGTH} characters or fewer`
	}
	if (!HOSTNAME_PATTERN.test(host)) {
		return 'Enter a valid hostname, for example broker.example.com'
	}
	return null
}

export const validateBrokerPort = (value: string): string | null => {
	const port = value.trim()
	if (!port) {
		return 'Broker port cannot be empty'
	}
	if (!/^\d+$/.test(port)) {
		return 'Broker port must be a whole number'
	}
	const parsed = Number.parseInt(port, 10)
	if (parsed < MIN_BROKER_PORT || parsed > MAX_BROKER_PORT) {
		return `Broker port must be between ${MIN_BROKER_PORT} and ${MAX_BROKER_PORT}`
	}
	return null
}
